import { RequestResource } from './request.resource';

export class RequestCreateResource {
  request: RequestResource;
}